
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-window-mock/-embroider-implicit-modules.js";
